(() => {
  if (window.laniusReferralInvite) return;
  window.laniusReferralInvite = true;

  const STORAGE = 'lanius-referral';
  const localPreview = location.hostname === '127.0.0.1' || location.hostname === 'localhost';
  const UNAVAILABLE = localPreview
    ? 'Die lokale Vorschau kann Shopjar nicht erreichen. Absenden funktioniert auf der Shop-Vorschau oder auf www.lanius.com/pages/referral.'
    : 'Das Empfehlungsprogramm ist gerade nicht verfügbar. Bitte lade die Seite neu.';
  const section = document.querySelector('.referral-invite');
  const form = section?.querySelector('[data-shopjar-referral]');
  const result = section?.querySelector('[data-referral-result]');
  const linkField = section?.querySelector('[data-referral-link]');
  const inviteForm = section?.querySelector('[data-referral-invite]');
  if (!section || !(form instanceof HTMLFormElement) || !result || !(linkField instanceof HTMLInputElement)) return;

  const setStatus = (node, message, ok) => {
    if (!(node instanceof HTMLElement)) return;
    node.hidden = !message;
    node.textContent = message || '';
    node.classList.toggle('referral-invite__status--ok', Boolean(ok));
  };

  const readSession = () => {
    try {
      const value = JSON.parse(sessionStorage.getItem(STORAGE) || '');
      if (value?.link && value?.memberId) return value;
    } catch (error) {
      return null;
    }
    return null;
  };

  const showResult = (link) => {
    form.hidden = true;
    result.hidden = false;
    linkField.value = link;
  };

  const postShopjar = async (path, body) => {
    const proxy = window.Shopjar?.settings?.proxy_url || '/a/shopjar-referral';
    const response = await fetch(`${location.origin}${proxy}${path}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body)
    });
    const data = await response.json().catch(() => null);
    return { ok: response.ok, data };
  };

  document.querySelector('.shopify-app-block:has(#sj_rlp_landing_page_main)')?.setAttribute('aria-hidden', 'true');

  const saved = readSession();
  if (saved) showResult(saved.link);

  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const name = form.querySelector('[name="name"]');
    const email = form.querySelector('[name="email"]');
    const submit = form.querySelector('[type="submit"]');
    const guestName = name instanceof HTMLInputElement ? name.value.trim() : '';
    const guestEmail = email instanceof HTMLInputElement ? email.value.trim() : '';
    if (!guestName || !guestEmail) return;

    if (submit instanceof HTMLButtonElement) submit.disabled = true;
    setStatus(form.querySelector('[data-referral-status]'), '');

    try {
      const { ok, data } = await postShopjar('/referral/advocate/page-sign-up-v2', {
        guestName,
        guestEmail,
        phone: ''
      });
      const link = data?.data?.referralLink;
      const memberId = data?.data?.memberId;
      if (!ok || !data?.status || !link || !memberId) {
        setStatus(form.querySelector('[data-referral-status]'), data?.message || UNAVAILABLE);
        return;
      }
      sessionStorage.setItem(STORAGE, JSON.stringify({ link, memberId }));
      showResult(link);
    } catch (error) {
      setStatus(form.querySelector('[data-referral-status]'), UNAVAILABLE);
    } finally {
      if (submit instanceof HTMLButtonElement) submit.disabled = false;
    }
  });

  section.querySelector('[data-referral-copy]')?.addEventListener('click', async () => {
    const label = section.querySelector('[data-referral-copy-label]');
    try {
      await navigator.clipboard.writeText(linkField.value);
      if (label) label.textContent = 'Kopiert';
    } catch (error) {
      linkField.select();
    }
  });

  inviteForm?.addEventListener('submit', async (event) => {
    event.preventDefault();
    const record = readSession();
    const email = inviteForm.querySelector('[name="friend"]');
    const submit = inviteForm.querySelector('[type="submit"]');
    const friend = email instanceof HTMLInputElement ? email.value.trim() : '';
    const status = inviteForm.querySelector('[data-referral-invite-status]');
    if (!record || !friend) {
      setStatus(status, UNAVAILABLE);
      return;
    }

    if (submit instanceof HTMLButtonElement) submit.disabled = true;
    setStatus(status, '');

    try {
      const { ok, data } = await postShopjar('/referral/advocate/invite-friend-v2', {
        email: friend,
        member_id: record.memberId,
        type: 'referral'
      });
      setStatus(status, data?.message || UNAVAILABLE, Boolean(ok && data?.status));
      if (ok && data?.status && email instanceof HTMLInputElement) email.value = '';
    } catch (error) {
      setStatus(status, UNAVAILABLE);
    } finally {
      if (submit instanceof HTMLButtonElement) submit.disabled = false;
    }
  });
})();
